<template>
  <div>
    <span>{{ $t('bill.bill_project_sharing') }}</span> <help-tooltip :text="$t('bill.bill_project_sharing_tips')" /> :
    <a-switch class="ml-1" v-model="projectShared" @change="change" />
  </div>
</template>

<script>

export default {
  name: 'ProjectShared',
  props: {
    projectShared: Boolean,
  },
  data () {
    return {}
  },
  methods: {
    change (e) {
      this.$store.commit('bill/UPDATE_PROJECT_SHARED', e)
      this.$emit('update:projectShared', e)
    },
  },
}
</script>
